import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyEntityPurchaseCreditLimitsContainerModel } from "../../../../../../models/aggregates/company";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class CompanyEntityPurchaseCreditLimitService extends BaseApiTemplateService<CompanyEntityPurchaseCreditLimitsContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "company-entity-purchase-credit-limits/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "company-entity-purchase-credit-limits/backoffice-ep";
    this.httpClient = http;
  }
}
